import * as React from 'react'

import { PlaidStatus } from 'embed/constants'
import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  plaidStatus: PlaidStatus | undefined
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepEmail: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    {props.plaidStatus !== PlaidStatus.Loading && (
      <>
        <StepTitle>What’s your email address?</StepTitle>
        <ApplicationField product={Product.Loan} field={Fields.EmailAddress} onEnter={props.onEnter} />
      </>
    )}
  </Wrapper>
)

export default StepbystepApplicationStepEmail
